// third party and libraries
import React, { useState } from 'react';
import { Modal, Button, Spinner } from "react-bootstrap";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

// Map container style
const containerStyle = {
    width: "100%",
    height: "400px",
};

// Default center position
const defaultCenter = {
    lat: 18.029438,
    lng: 102.548258,
};

export default function ShopMap({ isAddMap, onCloseMap, loadingUpdateSetting, setGoogleMapEdit }) {
    // state
    const [selectedPosition, setSelectedPosition] = useState(null);
    const [mapType, setMapType] = useState('roadmap');

    // Handle map click and store the clicked coordinates
    const handleMapClick = (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        setSelectedPosition({ lat, lng });
    };

    // Handle Save button click (perform actions with selected position)
    const handleSaveGoogleMap = async () => {
        if (loadingUpdateSetting) return;
        let googleMapLink = `https://www.google.com/maps?q=${selectedPosition?.lat},${selectedPosition?.lng}`;
        setGoogleMapEdit(googleMapLink)
    };

    return (
        <Modal size='lg' centered show={isAddMap} onHide={onCloseMap}>
            <Modal.Header closeButton>
                <Modal.Title>ເລືອກທີຕັ້ງຂອງຮ້ານ ປັດຈຸບັນ</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ minHeight: '40vh' }}>
                <LoadScript googleMapsApiKey="AIzaSyD_PTw7BIk4YaPRVuCIINpz9itj2Jj4K7c">
                    <GoogleMap
                        mapContainerStyle={containerStyle}
                        center={defaultCenter}
                        zoom={10}
                        onClick={handleMapClick}
                        mapTypeId={mapType}
                    >
                        {/* Marker for the selected position */}
                        {selectedPosition && (
                            <Marker position={selectedPosition} />
                        )}
                    </GoogleMap>
                </LoadScript>

                {/* Map Mode Selector */}
                <div style={{ marginTop: '20px' }}>
                    <Button variant={mapType === "roadmap" ? "secondary" : "outline-secondary"} onClick={() => setMapType('roadmap')} style={{ marginLeft: '10px' }}>ແບບທຳມະດາ</Button>
                    <Button variant={mapType === "hybrid" ? "secondary" : "outline-secondary"} onClick={() => setMapType('hybrid')} style={{ marginLeft: '10px' }}>ດາວທຽມ</Button>
                    <Button variant={mapType === "terrain" ? "secondary" : "outline-secondary"} onClick={() => setMapType('terrain')} style={{ marginLeft: '10px' }}>ພູມສານຖານ</Button>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="ligth" color='secondary' onClick={onCloseMap}>Cancel</Button>
                <Button variant="info" onClick={handleSaveGoogleMap}> {loadingUpdateSetting ? <Spinner size="sm" /> : "Save"}</Button>
            </Modal.Footer>
        </Modal>
    );
}
